export default __webpack_public_path__ + "doorbell_sunray.28d2cab9.png";